module.exports = __webpack_public_path__ + "img/DAB-Profile-Bhargav-Marepally.7ba826e1.png";